module.exports = __webpack_public_path__ + "static/img/Luke-Urquhart.4cb2432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Urquhart.jpg
// module id = Md5h
// module chunks = 0